/* @ngInject */
function BrandSectionFilesGroupController ($scope, $rootScope, $translate, $q, $timeout, $state, UdsModalService, ModalService, BrandService, BrandColorPaletteService, BrandFontsService, MessageService, ToastService, SegmentService, AssetService, AssetPreviewService) {
  const getPaletteColorFormDialogController = () => $q.when(import('../../dialogs/palette-color-form/palette-color-form-dialog.controller'))
  const getConfirmFontUploadDialogController = () => $q.when(import('../../dialogs/confirm-font-upload/confirm-font-upload-dialog.controller'))
  const getBrandSectionCategoryFormDialogController = () => $q.when(import('../../dialogs/brand-section-category-form/brand-section-category-form-dialog.controller'))
  const getDeleteBrandSectionDialogController = () => $q.when(import('../../../admin/dialogs/delete-brand-section/delete-brand-section-dialog.controller'))
  const getAttachInsideTheModuleModalController = () => $q.when(import('../../../repository/directives/attach-inside-the-module-modal/attach-inside-the-module-modal.controller'))

  $scope.flags = {
    loading: false
  }
  $scope.assets = []
  $scope.uploadingFonts = []
  $scope.data = {
    selectedAssets: []
  }
  $scope.assetsTop = 12
  $scope.currentSkipToken = 0
  $scope.iTokensCount = $rootScope.isDesktop ? 10 : 5
  $scope.assetsCount = 0
  $scope.getBrandSectionIconByType = BrandService.getBrandSectionIconByType
  const location = 'brand'

  const api = {
    getPaletteColorFormDialogController,
    getConfirmFontUploadDialogController,
    getBrandSectionCategoryFormDialogController,
    getDeleteBrandSectionDialogController,
    _getAssets,
    _getFonts,
    _handleSuccessGetAssets,
    _handleSuccessUploadAsset,
    _handleSuccessDeleteColor,
    _handleSuccessDeleteCategory,
    _handleSuccessBulkArchiveAssets,
    _handleSuccessBulkDeleteFonts,
    _handleSuccessGetFonts,
    _handleBulkDeleteSelectedAssets,
    _handleDeleteColorPress,
    _handleErrorGetAssets,
    _handleErrorDelete,
    _areValidFontFiles,
    _isValidImagesFilesForEditor,
    _showUploadFontConfirmation,
    _defineContentTypes,
    _successUploadFonts,
    _uploadOnProgress,
    _lowerCaseFilesExtensions,
    _errorUploadFonts,
    _handleRGBAndCMYK,
    _getPreviewAssets,
    _onDeleteAsset,
    _removeObjectsByAssetId,
    _isValidImagesFilesSize
  }
  this.getApi = () => api

  activate()

  function activate () {
    $rootScope.getUser().then(user => {
      // should keep tile space for upload tile
      if (!$rootScope.isUser(user)) {
        $scope.assetsTop = $scope.assetsTop - 1
      }

      api._defineContentTypes($scope.section)

      if ($scope.section.type === 'FONT') {
        api._getFonts($scope.assetsTop, $scope.currentSkipToken, $scope.category)
      } else if ($scope.section.type !== 'COLOR') {
        api._getAssets($scope.assetsTop, $scope.currentSkipToken, $scope.section, $scope.category)
      }
    })
  }

  const deregisterSuccessDeleteFont = $scope.$on('successDeleteFont', () => {
    api._getFonts($scope.assetsTop, $scope.currentSkipToken, $scope.category)
  })

  const deregisterSuccessArchiveAsset = $scope.$on('successArchiveAsset', () => {
    api._getAssets($scope.assetsTop, $scope.currentSkipToken, $scope.section, $scope.category)
  })

  const deregisterSuccessUnlinkBrandSectionAsset = $scope.$on('successUnlinkBrandSectionAsset', () => {
    api._getAssets($scope.assetsTop, $scope.currentSkipToken, $scope.section, $scope.category)
  })

  $scope.$on('$destroy', () => {
    deregisterSuccessDeleteFont()
    deregisterSuccessArchiveAsset()
    deregisterSuccessUnlinkBrandSectionAsset()
  })

  $scope.handleUploadAsset = (section, categoryId) => {
    const isEditorSection = ['LOGO', 'ICON', 'IMAGE', 'BACKGROUND'].includes(section.type)

    getAttachInsideTheModuleModalController().then(({ AttachInsideTheModuleModalController }) => {
      const attachInsideTheModuleModal = UdsModalService.createModal({
        controller: AttachInsideTheModuleModalController,
        modalName: 'attachInsideTheModuleModal',
        data: {
          generateThumbnailSyncOnUpload: true,
          selectedTab: 'recents',
          allowedAssetExtensionsSelection: $scope.assetAttachAcceptance,
          confirmAttachAssetValidator: isEditorSection ? api._isValidImagesFilesSize : null
        },
        onClose: (assetsToAttach) => {
          if (!assetsToAttach?.length) {
            return
          }

          const assetsId = assetsToAttach.map((asset) => asset.id)
          BrandService.attachAssetsToBrandSection(section.id, assetsId, categoryId).then(() => {
            api._handleSuccessUploadAsset({ trackEvent: true })
          })
        }
      })

      attachInsideTheModuleModal.open()
    })
  }

  $scope.handleUploadAssetLegacy = function (assets, section, categoryId) {
    if (assets.length === 0) {
      return
    }

    if (section.type === 'FONT') {
      if (api._areValidFontFiles(assets)) {
        api._showUploadFontConfirmation(assets, categoryId)
      }
      return
    }

    // assets used in editor
    if (section.type === 'LOGO' || section.type === 'ICON' || section.type === 'IMAGE' || section.type === 'BACKGROUND') {
      if (!api._isValidImagesFilesForEditor(assets)) {
        ToastService.showErrorToast($translate.instant('dashboard.invalidImageFormatErrorMsg'))
        return
      }

      if (!api._isValidImagesFilesSize(assets)) {
        return
      }

      BrandService.preventUploadWebp(assets, section, categoryId, 0, false, api._handleSuccessUploadAsset)
    } else {
      BrandService.createBrandSectionAssets(assets, section.id, { successCallback: api._handleSuccessUploadAsset.bind(this, { trackEvent: true }) }, { brandSectionCategoryId: categoryId })
    }
  }

  $scope.handleDeleteColor = function (palette, color, index) {
    MessageService.warning({
      title: $translate.instant('warning'),
      text: $translate.instant('dashboard.areYouSureDeletePaletteColor'),
      confirmButton: $translate.instant('yesImSure'),
      cancelButton: $translate.instant('cancel'),
      press: api._handleDeleteColorPress.bind(undefined, palette, color, index),
      closeOnConfirm: true
    })
  }

  $scope.skipPagingTo = function (token, section) {
    $scope.currentSkipToken = token
    if (section.type === 'FONT') {
      api._getFonts($scope.assetsTop, $scope.currentSkipToken, $scope.category)
    } else {
      api._getAssets($scope.assetsTop, $scope.currentSkipToken, section, $scope.category)
    }
  }

  $scope.handleCreatePaletteColor = function (palette) {
    if (!palette.colors) {
      palette.colors = []
    }

    api.getPaletteColorFormDialogController().then(({ PaletteColorFormDialogController }) => {
      ModalService.showModal({
        templateId: 'paletteColorForm.html',
        templateUrl: '/brand/dialogs/palette-color-form/palette-color-form-dialog.html?$$REVISION$$',
        destroyable: true,
        controller: PaletteColorFormDialogController,
        data: {
          palette: palette
        }
      })
        .then(newColor => {
          if (!palette.colors) {
            palette.colors = []
          }
          if (newColor) {
            api._handleRGBAndCMYK(newColor)
            palette.colors.push(newColor)
          }
        })
    })
  }

  $scope.handleEditColor = function (palette, color) {
    api.getPaletteColorFormDialogController().then(({ PaletteColorFormDialogController }) => {
      ModalService.showModal({
        templateId: 'paletteColorForm.html',
        templateUrl: '/brand/dialogs/palette-color-form/palette-color-form-dialog.html?$$REVISION$$',
        destroyable: true,
        controller: PaletteColorFormDialogController,
        data: {
          palette: palette,
          color: color
        }
      })
        .then(newColor => {
          if (newColor) {
            color.rgb = newColor.rgb
            color.cmyk = newColor.cmyk

            api._handleRGBAndCMYK(color)

            color.hex = newColor.hex
            color.pantone = newColor.pantone
            color.updatedAt = new Date().toISOString()
          }
        })
    })
  }

  $scope.handleUpdateCategory = function (category) {
    api.getBrandSectionCategoryFormDialogController().then(({ BrandSectionCategoryFormDialogController }) => {
      const dialog = UdsModalService.createModal({
        controller: BrandSectionCategoryFormDialogController,
        modalName: 'brandSectionCategoryFormDialog',
        data: {
          section: $scope.section,
          category: $scope.category
        },
        onClose: (updatedCategory) => {
          if (updatedCategory) {
            $scope.category.name = updatedCategory.name
          }
        }
      })

      dialog.open()
    })
  }

  $scope.handleDeleteCategory = function (category, section, assets) {
    api.getDeleteBrandSectionDialogController().then(({ DeleteBrandSectionDialogController }) => {
      ModalService.showModal({
        templateId: 'deleteBrandSection.html',
        templateUrl: '/admin/dialogs/delete-brand-section/delete-brand-section-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: DeleteBrandSectionDialogController,
        data: {
          data: {
            section,
            category,
            assets
          },
          type: 'subsection'
        }
      }).then((deleted) => {
        if (deleted) {
          ModalService.close(true)
          $scope.$emit('reloadBrandSections')
        }
      })
    })
  }

  $scope.handleBulkDeleteClick = function (selectedAssets, section) {
    MessageService.warning({
      title: $translate.instant('warning'),
      text: $translate.instant('areYouSureDeleteSelectedItens'),
      confirmButton: $translate.instant('yesImSure'),
      cancelButton: $translate.instant('cancel'),
      press: api._handleBulkDeleteSelectedAssets(selectedAssets, section),
      closeOnConfirm: true
    })
  }

  $scope.showEmptyMessage = function (assets, category, section, loading) {
    const sectionCategories = $scope.$parent.categories
    if ($rootScope.isUser()) {
      if (section && section.type === 'COLOR') {
        if (category.colors) {
          return !category.colors.length
        }

        return true
      }

      if (sectionCategories.length) {
        if (category) {
          return !assets.length
        }

        return false
      }

      return !assets.length
    }

    return false
  }

  function _isValidImagesFilesSize (assets) {
    const isValid = BrandService.isValidImageFileSize(assets)

    if (!isValid) {
      ToastService.showErrorToast($translate.instant('brand.error.maxFileSizeContent'))
    }

    return isValid
  }

  function _defineContentTypes (section) {
    if (section.type === 'IMAGE' || section.type === 'LOGO' || section.type === 'BACKGROUND' || section.type === 'ICON') {
      $scope.assetAttachAcceptance = ['png', 'jpeg', 'jpg']
      $scope.contentTypeAcceptence = 'image/*'
    } else if (section.type === 'VIDEO') {
      $scope.assetAttachAcceptance = ['mp4', 'mov', 'mpeg', 'mpg', 'avi', 'wmv', 'flv', 'm4v', 'qt']
      $scope.contentTypeAcceptence = 'video/*'
    } else {
      $scope.assetAttachAcceptance = [] // this means all files
      $scope.contentTypeAcceptence = '*'
    }
  }

  function _handleDeleteColorPress (palette, color, index) {
    $scope.flags.loading = true
    BrandColorPaletteService.deletePaletteColor(palette.id, color.id).then(api._handleSuccessDeleteColor.bind(undefined, palette, index)).catch(api._handleErrorDelete)
  }

  function _showUploadFontConfirmation (files, categoryId) {
    api.getConfirmFontUploadDialogController().then(({ ConfirmFontUploadDialogController }) => {
      ModalService.showModal({
        templateId: 'confirmFontUpload.html',
        templateUrl: '/brand/dialogs/confirm-font-upload/confirm-font-upload-dialog.html?$$REVISION$$',
        controller: ConfirmFontUploadDialogController,
        data: {
          fontFiles: files,
          fontFields: {
            brandSectionCategoryId: categoryId
          }
        },
        destroyable: true
      })
        .then(function (data) {
          if (data) {
            $scope.uploadingFonts.push(...data.fonts)
            BrandFontsService.uploadFont(data.fonts, api._successUploadFonts, api._uploadOnProgress, data.fontFields, true, api._errorUploadFonts)
          }
        })
    })
  }

  function _isValidImagesFilesForEditor (files) {
    let isValid = true
    files.forEach(file => {
      if (!BrandService.isValidImageFileForEditor(file.name)) {
        isValid = false
      }
    })
    return isValid
  }

  function _areValidFontFiles (files) {
    const MAX_FONT_SIZE = 8 * 1024 * 1024 // 8mb in bytes
    let areValid = true
    let error = null

    files.forEach(file => {
      if (file.size > MAX_FONT_SIZE) { // 8 MB is the max size we allow, the value is in bytes
        areValid = false
        error = 'size'
      }
      if (!BrandFontsService.isValidFileFormat(file.name)) {
        areValid = false
        error = error === 'size' ? 'size' : 'format'
      }
    })

    if (areValid) {
      return true
    } else {
      if (error === 'size') {
        ToastService.showErrorToast($translate.instant('maxUploadSizeExceededFontMsg'))
        return false
      } else if (error === 'format') {
        ToastService.showErrorToast($translate.instant('dashboard.invalidFontFormatErrorMsg'))
        return false
      }
    }
  }

  function _getAssets (top, skipToken, section, category) {
    $scope.flags.loading = true
    BrandService.getBrandSectionAssets({
      top: top,
      skip: top * skipToken,
      sectionId: section.id,
      brandSectionCategoryId: category ? category.id : null
    }).then(api._handleSuccessGetAssets).then(() => {
      if ($state.params?.previewId && !AssetPreviewService.assetPreviewIsOpen()) {
        const assetExistsInSection = $scope.assets.find((asset) => asset.id === Number($state.params.previewId))

        if (!assetExistsInSection) {
          return
        }

        $scope.openPreview(assetExistsInSection)
      }
    }).catch(api._handleErrorGetAssets)
  }

  function _getFonts (top, skipToken, category) {
    $scope.flags.loading = true
    const options = {
      top: top,
      skip: top * skipToken,
      brandSectionCategoryId: category ? category.id : null
    }
    BrandFontsService.getFonts(options).then(api._handleSuccessGetFonts).then(api._handleSuccessGetAssets).catch(api._handleErrorGetAssets)
  }

  function _handleSuccessDeleteCategory () {
    $scope.$destroy()
    $('#brand-section-' + $scope.section.id + '-category-' + $scope.category.id).empty()
  }

  function _handleSuccessDeleteColor (palette, index) {
    palette.colors.splice(index, 1)
    $scope.flags.loading = false
  }

  function _handleSuccessGetFonts (response) {
    BrandFontsService.loadFontsOnCSS(response.d.results)
    return response
  }

  function _handleSuccessGetAssets (response) {
    $scope.assets = response.d.results
    $scope.assetsCount = response.d.__count
    $scope.flags.loading = false
  }

  function _handleSuccessUploadAsset (info) {
    if (info && info.trackEvent) {
      SegmentService.track('brand-uploads')
    }
    $scope.currentSkipToken = 0
    api._getAssets($scope.assetsTop, $scope.currentSkipToken, $scope.section, $scope.category)
  }

  function _handleErrorDelete () {
    $scope.flags.loading = false
    ToastService.defaultErrorToast()
  }

  function _handleErrorGetAssets () {
    $scope.flags.loading = false
  }

  function _handleSuccessBulkArchiveAssets () {
    $scope.data.selectedAssets = []
    api._handleSuccessUploadAsset()
  }

  function _handleSuccessBulkDeleteFonts () {
    $scope.data.selectedAssets = []
    $scope.currentSkipToken = 0
    api._getFonts($scope.assetsTop, $scope.currentSkipToken, $scope.category)
  }

  function _handleBulkDeleteSelectedAssets (selectedAssets, section) {
    return () => {
      $scope.flags.loading = true
      const assetsId = selectedAssets.map(asset => asset.id)
      if (section.type === 'FONT') {
        BrandFontsService.bulkDeleteBrandSectionFont({ fontsId: assetsId }).then(api._handleSuccessBulkDeleteFonts).catch(api._handleErrorDelete)
      } else {
        BrandService.batchUnlinkBrandSectionAsset(section.id, assetsId)
          .then(api._handleSuccessBulkArchiveAssets)
          .catch(api._handleErrorDelete)
        // AssetService.getAssetsWithArts(assetsId)
        //   .then(assetsWithArts => {
        //     const assetsWithNoArts = assetsId.filter(id => !assetsWithArts.includes(id))
        //     const promises = []

        //     if (assetsWithArts.length) {
        //       promises.push(
        //         AssetService.bulkArchiveBrandSectionAsset(assetsWithArts)
        //       )
        //     }

        //     if (assetsWithNoArts.length) {
        //       promises.push(
        //         BrandService.bulkDeleteBrandSectionAsset(assetsWithNoArts)
        //       )
        //     }

        //     $q.all(promises)
        //       .then(api._handleSuccessBulkArchiveAssets)
        //       .catch(api._handleErrorDelete)
        //   })
      }
    }
  }

  function _successUploadFonts (res) {
    api._lowerCaseFilesExtensions()
    const assetIndex = $scope.uploadingFonts.findIndex(item => item.name === res.data[0].name && item.size === res.data[0].originalSize)

    if (assetIndex !== -1) {
      $scope.assets.push(res.data[0])
      $scope.uploadingFonts.splice(assetIndex, 1)
    } else {
      $timeout(() => {
        $scope.currentSkipToken = 0
        api._getFonts($scope.assetsTop, $scope.currentSkipToken, $scope.category)
      }, 5000)
    }
  }

  function _uploadOnProgress (file) {
    return function (event) {
      if (!event.lengthComputable) {
        return
      }

      const percentage = event.loaded / event.total * 100
      file.percentage = parseInt(percentage, 10)
    }
  }

  function _lowerCaseFilesExtensions () {
    $scope.uploadingFonts.forEach(font => {
      const nameArray = font.name.split('.')

      if (nameArray && nameArray.length && nameArray.length === 2) {
        const newName = nameArray[0] + '.' + nameArray[1].toLowerCase()

        Object.defineProperty(font, 'name', {
          writable: true,
          value: newName
        })
      }
    })
  }

  function _errorUploadFonts (e) {
    if (e && e.data.code === 'BAD_REQUEST_ERROR') {
      ToastService.showErrorToast($translate.instant('fontAlreadyExists'))
    }

    const index = $scope.uploadingFonts.findIndex(item => item === e.config.data.files[0])
    if (index !== -1) {
      $scope.uploadingFonts.splice(index, 1)
    }
  }

  function _handleRGBAndCMYK (color) {
    if (color.rgb && typeof color.rgb === 'string') {
      const rgbArray = color.rgb.split(',')
      color.rgb = {
        r: rgbArray[0] !== 'null' ? rgbArray[0] : '',
        g: rgbArray[1] !== 'null' ? rgbArray[1] : '',
        b: rgbArray[2] !== 'null' ? rgbArray[2] : ''
      }
    }

    if (color.cmyk && typeof color.cmyk === 'string') {
      const cmykArray = color.cmyk.split(',')
      color.cmyk = {
        c: cmykArray[0] !== 'null' ? cmykArray[0] : '',
        m: cmykArray[1] !== 'null' ? cmykArray[1] : '',
        y: cmykArray[2] !== 'null' ? cmykArray[2] : '',
        k: cmykArray[3] !== 'null' ? cmykArray[3] : ''
      }
    }
  }

  $scope.openPreview = async (asset) => {
    AssetService.getAssetDetailsById(asset.id).then(asset => {
      AssetPreviewService.openAssetPreview({
        asset: asset,
        getPreviewAssets: api._getPreviewAssets,
        location,
        section: $scope.section,
        onDeleteAsset: (sectionId, assetId) => {
          api._onDeleteAsset(sectionId, assetId)
        }
      })
    })
  }

  function _getPreviewAssets () {
    const deferred = $q.defer()
    $timeout(() => {
      deferred.resolve({
        assets: $scope.assets,
        count: $scope.assets.length
      })
    }, 100, true)
    return deferred.promise
  }

  function _onDeleteAsset (sectionId, assetId) {
    MessageService.warning({
      title: $translate.instant('warning'),
      text: $translate.instant('areYouSureDeleteAssetSingular'),
      confirmButton: $translate.instant('yesImSure'),
      cancelButton: $translate.instant('cancel'),
      closeOnConfirm: true,
      press: function (shouldDelete) {
        if (shouldDelete) {
          BrandService.unlinkBrandSectionAsset(sectionId, assetId)
            .then(() => {
              ToastService.defaultSuccessToast()
              $rootScope.$broadcast('successUnlinkBrandSectionAsset')
              $timeout(() => {
                const newAssets = api._removeObjectsByAssetId($scope.assets, assetId)
                $scope.assets = newAssets
                $rootScope.$emit('onDeleteAsset', { assetId, shouldClose: true })
              })
            })
            .catch(ToastService.defaultErrorToast)
        }
      }
    })
  }

  function _removeObjectsByAssetId (assets, assetId) {
    return assets.filter(asset => asset.id !== assetId)
  }
}

export { BrandSectionFilesGroupController }
